import { render } from "./ErrorMessage.vue?vue&type=template&id=6dce6b1a&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=6dce6b1a&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dce6b1a"]])

export default __exports__